import { Component, Input } from '@angular/core';
import { EntityType, Status } from '../../share';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-status-lables',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './status-lables.component.html',
  styleUrls: ['./status-lables.component.scss']
})
export class StatusLablesComponent {
  @Input() status!: string;
  @Input() entityType!: EntityType;

  constructor(private sanitizer: DomSanitizer) { }

  get statusInfo(): StatusInfo & { svgSafe?: SafeHtml } {
    const raw = StatusInfoMappings[this.entityType]?.[this.status as Status];
    if (raw) {
      return {
        ...raw,
        svgSafe: raw.svg ? this.sanitizer.bypassSecurityTrustHtml(raw.svg) : undefined
      };
    }
    
    // Handle custom status types for applicants
    const customStatus = CustomStatusMappings[this.status];
    if (customStatus) {
      return {
        ...customStatus,
        svgSafe: customStatus.svg ? this.sanitizer.bypassSecurityTrustHtml(customStatus.svg) : undefined
      };
    }
    
    return {
      text: 'Unknown',
      class: '',
    };
  }

}
export interface StatusInfo {
  text: string;
  class: string;
  svg?: string;  // <-- keep as string here
}

// 🔁 Updated with svgs
export const StatusInfoMappings: Record<EntityType, Record<Status, StatusInfo>> = {
  [EntityType.INSURER]: {
    [Status.RECEIVED]: {
      text: 'Received',
      class: 'green',
      svg: '✅'
    },
    [Status.SUBMITTED]: {
      text: 'Submitted',
      class: 'green',
      svg: '✅'
    },
    [Status.MORE_INFO_REQUESTED]: {
      text: 'Requested More Info',
      class: 'light-yellow',
      svg: '📩'
    },
    [Status.ADDED]: {
      text: 'Added',
      class: 'green',
      svg: '➕'
    },
    [Status.REJECTED]: {
      text: 'Rejected',
      class: 'red',
      svg: '❌'
    },
    [Status.REQUESTED]: {
      text: 'Requested',
      class: 'blue',
      svg: '📤'
    },
    [Status.OPEN]: {
      text: 'Open',
      class: 'openBlue',
      svg: '📂'
    },
    [Status.INPROGRESS]: {
      text: 'In Progress',
      class: 'in-progress',
      svg: '📂'
    },
    [Status.ACTIVE]: {
      text: 'Active',
      class: 'status-active',
      svg: '✅'
    },
    [Status.DEACTIVE]: {
      text: 'Deactived',
      class: 'status-deactive',
      svg: '❌'
    }
  }
};

// Custom status mappings for applicants table
export const CustomStatusMappings: Record<string, StatusInfo> = {
  'DRAFTED': {
    text: 'Draft',
    class: 'status-draft',
    svg: '📝'
  },
  'SUBMITTED_AWAITING_INSURER': {
    text: 'Submitted (Awaiting insurer)',
    class: 'status-submitted',
    svg: '⏳'
  },
  'SUBMITTED_AWAITING_ACCEPTANCE': {
    text: 'Submitted (awaiting Acceptance)',
    class: 'status-submitted',
    svg: '⏳'
  },
  'DECLINED_BY_INSURER': {
    text: 'Declined By Insurer',
    class: 'status-declined',
    svg: '❌'
  },
  'ON_RISK': {
    text: 'On Risk',
    class: 'status-on-risk',
    svg: '⚠️'
  },
  'NOT_TAKEN_UP': {
    text: 'Not taken Up [NTU]',
    class: 'status-ntu',
    svg: '🚫'
  }
};
